import { render } from "./withMenuSummaryModel.vue?vue&type=template&id=0f973f3a"
import script from "./withMenuSummaryModel.vue?vue&type=script&lang=js"
export * from "./withMenuSummaryModel.vue?vue&type=script&lang=js"

import "./withMenuSummaryModel.vue?vue&type=style&index=0&id=0f973f3a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__